import { render, staticRenderFns } from "./RiskNav.vue?vue&type=template&id=8eece2c6&scoped=true&"
import script from "./RiskNav.vue?vue&type=script&lang=js&"
export * from "./RiskNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eece2c6",
  null
  
)

export default component.exports